import React, { useContext, useState } from "react";
import ButtonCustom from "../../../../../../../../components/Button";
import { Dropdown } from "semantic-ui-react";
import { PUBLIC_URL } from "../../../../../../../App/configs/Constants";
import DropdownCustom from "../../../../../../../../components/DropdownCustom";
import { LocalizationContext } from "../../../../../../../../locales/Translation";
import { useDispatch } from "react-redux";
import { deskimoModalOfficeAction } from "../../../../../../actions/PropertyActions";
import { SWAL_DELETE_OPTION } from "../../../../../../../../components/SweetAlert/configs/SwalConfigs";
import { SweetAlertCommon } from "../../../../../../../../components/SweetAlert";
import {
  officeDeleteService,
  officeStatusToggleService,
  resyncDayOfficeIWGService,
} from "../../../../../../services/PropertyServices";
import {
  toastError,
  toastSuccess,
} from "../../../../../../../../components/Toast";
import { EDIT_TYPE } from "../../../../../../configs/Constants";

type Props = {
  id: string;
  status: number;
  onRefresh: () => void;
  companyId?: string;
  propertyId?: string;
  visibility?: boolean;
  visibilityAction?: string;
  isIWG?: boolean;
};

const ActionsButton = ({
  id,
  status,
  companyId,
  propertyId,
  isIWG,
  onRefresh,
}: Props) => {
  const { translations } = useContext(LocalizationContext);
  const dispatch = useDispatch();
  const [resyncing, setResyncing] = useState(false);

  const _handleResyncIWG = async (id: any) => {
    if (resyncing) return;
    setResyncing(true);
    try {
      const response = await resyncDayOfficeIWGService(id);
      toastSuccess(
        response?.status?.message || "Resynced from IWG successfully!"
      );
      onRefresh();
    } catch (error: any) {
      toastError(error?.status?.message || "Failed to resync from IWG.");
    } finally {
      setResyncing(false);
    }
  };

  const _handleDelete = (id: any) => {
    const icon = null;
    const iconHtml = (
      <img
        src={PUBLIC_URL + "/assets/icons/icon-error-red.svg"}
        className={"swal2-icon__error"}
      />
    );
    const title = "Are you sure want to delete this office?";
    const confirmText = translations.delete;
    const confirmClass = "danger";
    const options = SWAL_DELETE_OPTION({
      title,
      iconHtml,
      icon,
      confirmText,
      confirmClass,
    });

    SweetAlertCommon({
      options,
      confirmCallback: async () => {
        try {
          const payload = {
            day_office_id: id,
            company_id: companyId,
          };
          await officeDeleteService(payload);
          toastSuccess("Deleted Successfully!");
          onRefresh();
        } catch (error: any) {
          if (error?.status?.message) {
            toastError(error?.status?.message);
          }
        }
      },
      cancelCallback: () => null,
    });
  };
  const _handlePublish = (id: any, isPublish: number) => {
    const icon = null;
    const title = isPublish
      ? "Are you sure you want to publish this office?"
      : "Are you sure you want to unpublish this office?";
    const confirmText =
      isPublish > 0
        ? translations.propertyPage.publish
        : translations.propertyPage.unPublish;
    const confirmClass = "primary";
    const options = SWAL_DELETE_OPTION({
      title,
      icon,
      confirmText,
      confirmClass,
    });

    SweetAlertCommon({
      options,
      confirmCallback: async () => {
        try {
          const payload = {
            day_office_id: id,
            company_id: companyId,
          };
          await officeStatusToggleService(payload);
          toastSuccess(
            isPublish ? "Published Successfully!" : "Un-published Successfully!"
          );
          onRefresh();
        } catch (error: any) {
          if (error?.status?.message) {
            toastError(error?.status?.message);
          }
        }
      },
      cancelCallback: () => null,
    });
  };

  return (
    <DropdownCustom
      direction="left"
      icon={null}
      trigger={
        <ButtonCustom
          style={{ width: "38px", height: "38px" }}
          className="primary-alt"
        >
          <i className="uil uil-setting" style={{ fontSize: "21px" }} />
        </ButtonCustom>
      }
    >
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            dispatch(
              deskimoModalOfficeAction({
                isOpen: true,
                type: EDIT_TYPE,
                dayOfficeId: id,
                companyId: companyId,
                propertyId: propertyId,
              })
            );
          }}
          text="Edit Office"
          icon={
            <i className="uil uil-edit icon" style={{ fontSize: "16px" }} />
          }
        />
        {status > 0 ? (
          <Dropdown.Item
            onClick={() => _handlePublish(id, 0)}
            text="Un-publish"
            icon={
              <img
                alt="icon_toggle_slider_false"
                src={PUBLIC_URL + "/assets/icons/icon-toggle-slider.svg"}
              />
            }
          />
        ) : (
          <Dropdown.Item
            onClick={() => _handlePublish(id, 1)}
            text="Publish"
            icon={
              <img
                alt="icon_toggle_slider_true"
                src={PUBLIC_URL + "/assets/icons/icon-toggle-slider.svg"}
              />
            }
          />
        )}
        {isIWG ? (
          <Dropdown.Item
            onClick={() => _handleResyncIWG(id)}
            disabled={resyncing}
            text={resyncing ? "Resyncing..." : "Resync from IWG"}
            icon={
              <img
                alt="icon_sync"
                src={PUBLIC_URL + "/assets/icons/icon-sync-outline.svg"}
              />
            }
          />
        ) : null}
        <Dropdown.Item
          onClick={() => _handleDelete(id)}
          text={"Delete Office"}
          icon={
            <i
              className="uil uil-trash-alt icon"
              style={{ fontSize: "16px" }}
            />
          }
        />
      </Dropdown.Menu>
    </DropdownCustom>
  );
};

export default ActionsButton;
